module.exports = {"652928100":"阿瓦提镇","652928101":"乌鲁却勒镇","652928102":"拜什艾日克镇","652928200":"阿依巴格乡","652928201":"塔木托格拉克乡","652928202":"英艾日克乡","652928203":"多浪乡","652928204":"巴格托格拉克乡","652928405":"阿克苏监狱"}


//////////////////
// WEBPACK FOOTER
// ./src/town/652928.json
// module id = 2882
// module chunks = 0